import { useRef, useState } from "react";
import axios from "axios";
import { getBaseUrlOldForEnviornment } from "utils/constants";

export function UseLazyApiCallOldDashboard({ url, method, paramsData }) {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const controllerRef = useRef(null); // holds the current AbortController

  const baseUrl = getBaseUrlOldForEnviornment();

  const headers = {
    "Content-Type": "application/json",
  };

  async function getData(props) {
    const localData = props?.params || paramsData;
    const localUrl = props?.url || url;

    let apiResponseInitial = null;

    // Cancel the previous API request to prevent race conditions.
    // In live search (e.g., typing slowly), multiple requests may overlap.
    // Without cancellation, a slower earlier response might overwrite a newer one.
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    const controller = new AbortController();
    controllerRef.current = controller;
    const requestConfig = {
      method,
      url: `${baseUrl}/${localUrl}`,
      headers,
      data: JSON.stringify(localData),
      timeout: 100000,
      signal: controller.signal,
    };

    try {
      setIsLoading(true);

      const response = await axios.request(requestConfig);

      setData(response?.data);
      apiResponseInitial = response?.data;
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
    return apiResponseInitial;
  }
  function refetch() {
    getData();
  }

  return [getData, { data, isLoading, error, refetch }];
}
